import { createIcon } from './createIcon'

export const DcEmptyIcon = createIcon({
  displayName: 'DcEmptyIcon',
  viewBox: '0 0 20 20',
  path: [
    <path
      d="M1.66683 20.0001C1.44582 20.0001 1.23385 19.9123 1.07757 19.756C0.921293 19.5997 0.833496 19.3877 0.833496 19.1667V8.74172C0.833496 8.52071 0.921293 8.30874 1.07757 8.15246C1.23385 7.99618 1.44582 7.90839 1.66683 7.90839C1.88784 7.90839 2.0998 7.99618 2.25609 8.15246C2.41237 8.30874 2.50016 8.52071 2.50016 8.74172V19.1667C2.50016 19.3877 2.41237 19.5997 2.25609 19.756C2.0998 19.9123 1.88784 20.0001 1.66683 20.0001Z"
      fill="currentColor"
    />,
    <path
      d="M18.3333 20.0001C18.1123 20.0001 17.9004 19.9123 17.7441 19.756C17.5878 19.5997 17.5 19.3877 17.5 19.1667V8.74172C17.5 8.52071 17.5878 8.30874 17.7441 8.15246C17.9004 7.99618 18.1123 7.90839 18.3333 7.90839C18.5543 7.90839 18.7663 7.99618 18.9226 8.15246C19.0789 8.30874 19.1667 8.52071 19.1667 8.74172V19.1667C19.1667 19.3877 19.0789 19.5997 18.9226 19.756C18.7663 19.9123 18.5543 20.0001 18.3333 20.0001Z"
      fill="currentColor"
    />,
    <path
      d="M7.5835 13.375V9.375H12.4168V13.375H7.5835Z"
      fill="none"
      stroke="currentColor"
    />,
    <path
      d="M10.917 19.2084V15.2084H15.7503V19.2084H10.917Z"
      fill="none"
      stroke="currentColor"
    />,
    <path
      d="M4.25 19.2084V15.2084H9.08333V19.2084H4.25Z"
      fill="none"
      stroke="currentColor"
    />,
    <path
      d="M19.5418 7.07503C19.6046 7.074 19.6665 7.06032 19.7238 7.03483C19.7811 7.00933 19.8327 6.97253 19.8755 6.92663C19.9183 6.88073 19.9514 6.82668 19.9728 6.76769C19.9942 6.70871 20.0035 6.64602 20.0002 6.58336V3.74169C20.0017 3.64295 19.973 3.54608 19.9179 3.46414C19.8628 3.38219 19.7839 3.31911 19.6918 3.28336L10.5918 2.66396e-05C10.5032 -0.033212 10.4055 -0.033212 10.3168 2.66396e-05L0.316825 3.25003C0.216908 3.28768 0.131964 3.35684 0.0748329 3.44704C0.017702 3.53725 -0.00851017 3.6436 0.000158662 3.75003V6.58336C-0.00321135 6.64602 0.00608981 6.70871 0.0275059 6.76769C0.048922 6.82668 0.0820132 6.88073 0.1248 6.92663C0.167588 6.97253 0.219192 7.00933 0.276527 7.03483C0.333863 7.06032 0.395751 7.074 0.458492 7.07503H19.5418Z"
      fill="currentColor"
    />,
  ],
})
